import React from 'react';
import Table from 'src/componentes/table';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

const PontosPorFaixaResultadoPreview = ({ model, intl, resources }) => {
  const faixas = model?.faixas;
  const tipoPontoFaixaResultadoId = model?.tipoPontoFaixaResultado?.id;
  const interpolarValoresFaixa = model?.interpolarValoresFaixa;

  const isTipoMinMax = tipoPontoFaixaResultadoId === 4;
  const isTipoPercentual = tipoPontoFaixaResultadoId === 2;

  const handleMinimoMaximo = (valor) => {
    if (!valor) return '';
    if (valor.id == 1) return intl.formatMessage({ id: 'minimo' });
    if (valor.id == 2) return resources?.meta;
    if (valor.id == 3) return intl.formatMessage({ id: 'maximo' });
    return '';
  };

  const formatValor = (value) => {
    if (value == null) return '';

    const formatted = value.toLocaleString();
    return isTipoPercentual ? `${formatted}%` : formatted;
  };

  const formatPonto = (value) => {
    if (value == null) return '';
    return value.toLocaleString();
  };

  return (
    <div>
      {faixas && faixas.length > 0 ? (
        <Table>
          <thead>
            <tr>
              <th
                colSpan={2}
                style={{
                  fontWeight: 'bold',
                  borderBottom: '1px solid #dee2e6',
                  paddingBottom: 4,
                    textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                <FormattedMessage id="label.operacao" />
              </th>

              <th
                colSpan={interpolarValoresFaixa ? 3 : 1}
                style={{
                  fontWeight: 'bold',
                  borderBottom: '1px solid #dee2e6',
                  paddingBottom: 4,
                    textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                <FormattedMessage id="label.pontos" />
              </th>
            </tr>
          </thead>

          <tbody>
            {faixas.map((faixa, index) => (
              <tr key={index}>
                <td className='px-2'>
                  <span>
                    {faixa.operadorInferior &&
                      faixa.operadorInferior.simbolo}
                  </span>
                  <span style={{ marginLeft: 7 }}>
                    {isTipoMinMax
                      ? handleMinimoMaximo(faixa.minimoEMaximoInferior)
                      : formatValor(faixa.valorInferior)}
                  </span>
                </td>

                <td className='px-2'>
                  <span>
                    {faixa.operadorSuperior &&
                      faixa.operadorSuperior.simbolo}
                  </span>
                  <span style={{ marginLeft: 7 }}>
                    {isTipoMinMax
                      ? handleMinimoMaximo(faixa.minimoEMaximoSuperior)
                      : formatValor(faixa.valorSuperior)}
                  </span>
                </td>

                {interpolarValoresFaixa ? (
                  <>
                    <td className='px-2'>
                      {formatPonto(faixa.pontoInferior)}
                    </td>
                    <td className='px-2'>
                      {faixa.pontoInferior != null &&
                      faixa.pontoSuperior != null ? (
                        <FormattedMessage id="label.a" />
                      ) : null}
                    </td>
                    <td className='px-2'>
                      {formatPonto(faixa.pontoSuperior)}
                    </td>
                  </>
                ) : (
                  <td className='px-2'>{formatPonto(faixa.pontoInferior)}</td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <i>
          <FormattedMessage id="label.nenhumaFaixaConfiguradaParaEstaPolaridade" />
        </i>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(PontosPorFaixaResultadoPreview));
